import * as i0 from '@angular/core';
import { Component, Inject, NgModule, Injectable } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i2 from 'reference-library';
import * as i3 from 'primeng/dialog';
import * as i4 from 'primeng/api';
import * as i5 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';
import { initialState } from 'app-models';
import * as i2$1 from '@ngrx/store';
import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { of } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import * as i3$1 from 'ngx-ui-loader';

function ConfirmationModalComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
class ConfirmationModalComponent {
    constructor(dialogRef, referenceLibraryService, dialogData) {
        this.dialogRef = dialogRef;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogData = dialogData;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 1000);
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 12, vars: 4, consts: [["visible", "true", 3, "closable"], ["pTemplate", "header"], [1, "message"], [1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p-dialog", 0);
        i0.ɵɵtemplate(1, ConfirmationModalComponent_ng_template_1_Template, 2, 1, "ng-template", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p-footer");
        i0.ɵɵelementStart(6, "button", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_6_listener() { return ctx.onDismiss(); });
        i0.ɵɵelementStart(7, "span", 3);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "button", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_9_listener() { return ctx.onConfirm(); });
        i0.ɵɵelementStart(10, "span", 3);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("closable", false);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
    } }, directives: [i3.Dialog, i4.PrimeTemplate, i4.Footer, i5.ButtonDirective], styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}input.update-dialog[_ngcontent-%COMP%]{border:.5px solid #d2d2d2;border-radius:.2em;height:34px}.message[_ngcontent-%COMP%]{border-top:2px dashed grey;padding-top:15px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.yes-button[_ngcontent-%COMP%]{background-color:#3f51b5!important}.no-button[_ngcontent-%COMP%]{background-color:#ededed!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: i2.ReferenceLibraryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class DirtyCheckLibraryModule {
}
DirtyCheckLibraryModule.ɵfac = function DirtyCheckLibraryModule_Factory(t) { return new (t || DirtyCheckLibraryModule)(); };
DirtyCheckLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DirtyCheckLibraryModule });
DirtyCheckLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [ConfirmationModalComponent], imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DirtyCheckLibraryModule, { declarations: [ConfirmationModalComponent], imports: [PrimengLibraryModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirtyCheckLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [ConfirmationModalComponent],
                imports: [
                    PrimengLibraryModule
                ],
                providers: [ConfirmationModalComponent],
                exports: []
            }]
    }], null, null); })();

var ActionTypes;
(function (ActionTypes) {
    ActionTypes["DIRTY"] = "[formState] DIRTY";
    ActionTypes["CLEAN"] = "[formState] CLEAN";
})(ActionTypes || (ActionTypes = {}));
class MarkDirtyFormAction {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.DIRTY;
    }
}
class MarkCleanFormAction {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.CLEAN;
    } // form id
}

const { DIRTY, CLEAN } = ActionTypes;
function DirtyFormReducer(state = initialState, action) {
    switch (action.type) {
        case CLEAN:
            return Object.assign(Object.assign({}, state), { dirty: false, dirtyFormList: [], message: action.payload.message });
        case DIRTY:
            return Object.assign(Object.assign({}, state), { dirty: true, dirtyFormList: state.dirtyFormList ? [...state.dirtyFormList, action.payload['formName']] : [], message: action.payload.message });
        default:
            return Object.assign({}, state);
    }
}

const selectFeatureState = createFeatureSelector('formState');
const selectFormDirty = createSelector(selectFeatureState, (state) => {
    return state;
});

class DirtyFormGuard {
    constructor(dialog, store, ngxService) {
        this.dialog = dialog;
        this.store = store;
        this.ngxService = ngxService;
    }
    canDeactivate() {
        return this.store.pipe(select(selectFormDirty), mergeMap((dirtyObj) => {
            if (dirtyObj.dirty || (dirtyObj.dirtyFormList && dirtyObj.dirtyFormList.some((x) => x.dirtyStatus === true))) {
                // form is dirty or any one form is dirty in the array.
                this.ngxService.stopAll();
                return this.dialog.open(ConfirmationModalComponent, {
                    width: '400px',
                    data: {
                        update: {
                            title: 'Unsaved Changes!',
                            message: (dirtyObj.message) ? dirtyObj.message :
                                'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
                        },
                        buttons: ['No', 'Yes'],
                        disableClose: true
                    }
                }).afterClosed().pipe(map((confirmed) => {
                    return confirmed;
                }));
            }
            else {
                return of(true);
            }
        }));
    }
}
DirtyFormGuard.ɵfac = function DirtyFormGuard_Factory(t) { return new (t || DirtyFormGuard)(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2$1.Store), i0.ɵɵinject(i3$1.NgxUiLoaderService)); };
DirtyFormGuard.ɵprov = i0.ɵɵdefineInjectable({ token: DirtyFormGuard, factory: DirtyFormGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirtyFormGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.MatDialog }, { type: i2$1.Store }, { type: i3$1.NgxUiLoaderService }]; }, null); })();

/*
 * Public API Surface of dirty-check-store
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionTypes, ConfirmationModalComponent, DirtyCheckLibraryModule, DirtyFormGuard, DirtyFormReducer, MarkCleanFormAction, MarkDirtyFormAction, selectFeatureState, selectFormDirty };
//# sourceMappingURL=dirty-check-store.js.map
